export class FailedToGetTokenError extends Error {
  // if exception on sign in, the connector add error code to claims, that code should be shown on ui
  constructor(public readonly b2cErrorCode?: string) {
    super('Failed to get token');
  }
}
